import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { P } from 'sushiweb/Typography/Text';
import { Container } from './styles';
import FooterBar from './components/FooterBar';
// import Heading from './components/Heading';
import {
  // onBoardingSteps,
  successSubtitle,
  successTitle,
  validateDetailsLabel,
  // afterUpload,
} from './constants';
import VerificationModal from '../common/components/VerificationModal';
import CompanyProfile from './components/Forms/CompanyProfile';
// import EmployeeData from './components/Forms/EmployeeData';
import { ConfirmLabel } from './components/styles';
import { HOME_ROUTE } from '../../constants/routes';
import ErrorPage from '../common/components/ErrorPage';
import { REFRESH_LABEL } from '../common/components/constants';

const Onboarding = ({
  verified,
  isVerifying,
  // processId,
  // uploadMsg,
  // uploadEmployees,
  verificationSuccess,
  setCompanyVerified,
  verifyCompany,
  setSuccessModal,
  clearSuccessModal,
  // setFileUploadMsg,
  companyProfileFetched,
  companyData,
  clearUpload,
  // showErrorToast,
  // fileUploading,
  // fileUploaded,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentForm, setForm] = useState('step-1');
  const [formChecked, checkForm] = useState(false);
  // const [buttonStatus, setButtonStatus] = useState();
  // const [file, setFile] = useState();
  // const [loading, setLoading] = useState();
  // const [uploadStatus, setUploadStatus] = useState('');

  // const {
  //   heading: initialHeading = '',
  //   subheading: initialSubHeading = '',
  // } = onBoardingSteps[currentForm];
  // const [heading, setHeading] = useState(initialHeading);
  // const [subheading, setSubHeading] = useState(initialSubHeading);

  const {
    contact_details: contactDetails = {},
    legal_details: legalDetails = {},
  } = companyData;

  useEffect(() => {
    return () => {
      clearUpload();
    };
  }, [location.pathname]);

  useEffect(() => {
    if (verificationSuccess) {
      window.scrollTo(0, 0);
      // setForm('step-2');
    }
  }, [verificationSuccess, setForm]);

  const handleCheck = e => {
    checkForm(e.target.checked);
  };

  const refreshPage = () => {
    navigate(0);
  };

  // const updateButtonStatus = status => {
  //   setButtonStatus(status);
  // };

  // const uploadEmployeeData = () => {
  //   uploadEmployees(file);
  // };

  // const updateFile = data => {
  //   setFile(data);
  // };

  // const updateLoading = val => {
  //   setLoading(val || fileUploading);
  // };

  // const updateUploadStatus = val => {
  //   setUploadStatus(val);
  //   if (['failed', 'completed', 'terminated'].includes(val)) {
  //     setHeading(afterUpload.heading);
  //     setSubHeading(afterUpload.subheading);
  //   }
  // };

  const onContinueClick = () => {
    clearSuccessModal();
    clearUpload();
    setCompanyVerified(true);
    navigate(HOME_ROUTE, { replace: true });
  };

  // const goBack = () => {
  //   window.scrollTo(0, 0);
  //   if (currentForm === 'step-2') {
  //     setForm('step-1');
  //   }
  // };

  const goNext = () => {
    if (currentForm === 'step-1') {
      if (verificationSuccess) {
        window.scrollTo(0, 0);
        // setForm('step-2');
      } else {
        verifyCompany();
      }
    }
    // if (currentForm === 'step-2') {
    setSuccessModal({
      title: successTitle,
      subtitle: successSubtitle,
    });
    // }
  };

  const getForm = () => {
    if (currentForm === 'step-1') {
      return (
        <CompanyProfile
          contactDetails={contactDetails}
          legalDetails={legalDetails}
        />
      );
    }
    // if (currentForm === 'step-2') {
    //   return (
    //     <EmployeeData
    //       processId={processId}
    //       uploadMsg={uploadMsg}
    //       uploadEmployees={uploadEmployees}
    //       fileUploading={fileUploading}
    //       fileUploaded={fileUploaded}
    //       showErrorToast={showErrorToast}
    //       setFileUploadMsg={setFileUploadMsg}
    //       updateButtonStatus={updateButtonStatus}
    //       updateFile={updateFile}
    //       updateLoading={updateLoading}
    //       updateUploadStatus={updateUploadStatus}
    //     />
    //   );
    // }
    return null;
  };

  if (verified) {
    return <Navigate to={HOME_ROUTE} replace />;
  }

  if (!companyProfileFetched) {
    return (
      <>
        <Container>
          <ErrorPage
            showAction
            actionLabel={REFRESH_LABEL}
            clickAction={refreshPage}
          />
        </Container>
      </>
    );
  }

  return (
    <>
      <Container>
        <Container.Content>
          {/* <Heading heading={heading} subheading={subheading} /> */}
          {getForm()}
          {currentForm !== 'step-2' && (
            <ConfirmLabel>
              <input
                type='checkbox'
                checked={formChecked}
                onChange={handleCheck}
              />
              <P>{validateDetailsLabel()}</P>
            </ConfirmLabel>
          )}
          <VerificationModal onContinueClick={onContinueClick} />
        </Container.Content>
      </Container>
      <FooterBar
        currentForm={currentForm}
        formChecked={formChecked}
        // goBack={goBack}
        goNext={goNext}
        // disabled={buttonStatus}
        // uploadEmployeeData={uploadEmployeeData}
        isVerifying={isVerifying}
      // loading={loading}
      // uploadStatus={uploadStatus}
      />
    </>
  );
};

Onboarding.propTypes = {
  verified: PropTypes.bool,
  // uploadMsg: PropTypes.string,
  // processId: PropTypes.string,
  isVerifying: PropTypes.bool,
  // fileUploading: PropTypes.bool,
  // fileUploaded: PropTypes.bool,
  // setFileUploadMsg: PropTypes.func,
  // uploadEmployees: PropTypes.func,
  companyProfileFetched: PropTypes.bool,
  companyData: PropTypes.objectOf(PropTypes.any),
  verifyCompany: PropTypes.func,
  clearUpload: PropTypes.func,
  setSuccessModal: PropTypes.func,
  // showErrorToast: PropTypes.func,
  clearSuccessModal: PropTypes.func,
  setCompanyVerified: PropTypes.func,
  verificationSuccess: PropTypes.bool,
};

Onboarding.defaultProps = {
  verified: false,
  // processId: '',
  // uploadMsg: '',
  isVerifying: false,
  // fileUploading: false,
  // fileUploaded: false,
  companyProfileFetched: true,
  // uploadEmployees: _noop,
  // setFileUploadMsg: _noop,
  verificationSuccess: false,
  companyData: {},
  verifyCompany: _noop,
  clearSuccessModal: _noop,
  setSuccessModal: _noop,
  // showErrorToast: _noop,
  clearUpload: _noop,
  setCompanyVerified: _noop,
};

export default Onboarding;
